import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCreditCardAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCreditCardAdd"><Path d="M2 4H22V9H2V4Z" fill="currentColor"/><Path d="M2 11V20H13V14H16V11H2Z" fill="currentColor"/><Path d="M20 16V13H18V16H15V18H18V21H20V18H23V16H20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCreditCardAdd;
